// Utilitários de regras de jogo (blueprint)

/** Fonte única da taxonomia de ciclos — a Odisseia de Fases consome daqui
 *  para o seletor de abas nunca divergir das regras de jogo. */
export const CICLOS: { nome: string; fases: [number, number] }[] = [
  { nome: 'I. Despertar', fases: [1, 10] },
  { nome: 'II. Sabedoria', fases: [11, 20] },
  { nome: 'III. Resistência', fases: [21, 35] },
  { nome: 'IV. Legado', fases: [36, 49] },
  { nome: 'V. O Ápice', fases: [50, 50] },
];

export function getCicloPorFase(fase: number): string {
  const c = CICLOS.find(({ fases }) => fase >= fases[0] && fase <= fases[1]);
  return c?.nome ?? 'I. Despertar';
}

/** Máximo de ajudas permitidas na fase (Opção A: F1-10 = 1; F11-20 = 2; F21-35 = 3; F36-49 = 4; F50 = 0) */
export function getAjudasMaxPorFase(fase: number): number {
  if (fase === 50) return 0;
  if (fase <= 10) return 1;
  if (fase <= 20) return 2;
  if (fase <= 35) return 3;
  if (fase <= 49) return 4;
  return 0;
}

/** Duração do timer por pergunta em segundos (Fase 50 = 15s, resto = 30s) */
export function getTimerPorPergunta(fase: number): number {
  return fase === 50 ? 15 : 30;
}

/** Remove o último checkpoint salvo (duelo ou penalidade) */
export function perderUltimoCheckpoint(checkpointAtual: number): number {
  if (checkpointAtual >= 14) return 8;
  if (checkpointAtual >= 8) return 0;
  return 0;
}

const RUN_STATUSES = new Set(['PLAYING', 'ERROR_PORTAL', 'MINIGAME', 'GAME_OVER']);

export function isActiveRunStatus(status: string): boolean {
  return RUN_STATUSES.has(status);
}

/**
 * Função utilitária para embaralhar arrays de forma segura sem mutar a fonte.
 * Utiliza o algoritmo de Fisher-Yates.
 */
export function shuffleArray<T>(array: T[]): T[] {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
